import { Text, TextColor, TextSize } from '@vizit/atoms';

const ComboBoxEmpty = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="p-8">
      <Text size={TextSize.Sm} color={TextColor.Tertiary}>
        {children}
      </Text>
    </div>
  );
};

export { ComboBoxEmpty };
